import { render, staticRenderFns } from "./eAristoRootProfessorRootView.vue?vue&type=template&id=13861174"
import script from "./eAristoRootProfessorRootView.vue?vue&type=script&lang=js"
export * from "./eAristoRootProfessorRootView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports